<script>
export default {
  template: "#app-template",
  components: {
    Report: () => import("owner/views/reports/Index.vue"),
    PackageMenuForm: () => import("owner/views/package_menus/Index.vue"),
    ReservationDashboard: () =>
      import("owner/views/reservations/Dashboard.vue"),
    ReservationForm: () => import("owner/views/reservations/Form.vue"),
    Reviews: () => import("owner/views/Reviews.vue"),
    Override: () => import("owner/views/Override.vue"),
    SelfCheckin: () =>
      import("owner/views/reservations/selfCheckin/SelfCheckin.vue"),
    SelfRedeem: () =>
      import("owner/views/vouchers/selfRedeem/SelfRedeem.vue")
  }
};
</script>
